import { useCallback, useEffect, useState } from "react";
import baseUrl from "../api/baseUrl";

export type SmsAlertLevel = "depleted" | "inactive" | "low";

export type SmsAlertData = {
  enabled?: boolean;
  showAlert?: boolean;
  level?: SmsAlertLevel | null;
  message?: string | null;
  tokenCredits?: number | null;
  totalAvailable?: number | null;
  lowBalanceThreshold?: number | null;
};

const POLL_MS = 30 * 60 * 1000;

export function useSmsAlert() {
  const [alert, setAlert] = useState<SmsAlertData | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchAlert = useCallback(async () => {
    setLoading(true);
    try {
      const response = await baseUrl.get("/client/account/sms-alert", {
        params: { refresh: "false" },
      });
      if (response?.data?.success) {
        setAlert(response.data.data as SmsAlertData);
      } else {
        setAlert(null);
      }
    } catch {
      setAlert(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAlert();
    const pollId = window.setInterval(fetchAlert, POLL_MS);

    const onBalanceChanged = () => {
      fetchAlert();
    };
    window.addEventListener("sms-balance-changed", onBalanceChanged);

    return () => {
      window.clearInterval(pollId);
      window.removeEventListener("sms-balance-changed", onBalanceChanged);
    };
  }, [fetchAlert]);

  return { alert, loading, refetch: fetchAlert };
}
